module.exports = __webpack_public_path__ + "img/arrow-up.5819b55d.svg";